// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"80b3c846","453":"a5f90284"}[chunkId] + ".chunk.js";
};